
import { defineComponent, computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Tabbar, TabbarItem } from 'vant'
import { Auth } from '@loca/mfe-vue3'

export default defineComponent({
  name: 'MenuMobileComp',

  components: {
    'van-tabbar': Tabbar,
    'van-tabbar-item': TabbarItem
  },
  props: {
    showBorder: { type: Boolean, default: false },
    list: { type: Array, default: () => [] },
    optionAsValue: { type: Boolean, default: false }
  },
  setup(props) {
    const route = useRoute()

    const activeTab = ref(0)

    const getIconMaskStyle = (active: boolean, item: any) => {
      const url = active ? (item.iconImgActive || item.iconImg) : item.iconImg
      if (!url) return {}
      return {
        maskImage: `url(${url})`,
        WebkitMaskImage: `url(${url})`
      }
    }

    const listAuthed = computed((): any[] =>
      props.list.filter((item: any) => {
        let res = true
        if (item.auth) {
          if (Array.isArray(item.auth)) {
            res = item.auth.some((auth: string) => Auth.hasPermission(auth))
          } else {
            res = Auth.hasPermission(item.auth)
          }
        }
        return res
      })
    )

    function findActiveTab() {
      const path = route.path
      let targetActiveTab = -1
      // 优先通过 link 精确匹配（比较 path 部分，忽略 query，避免待办等带 query 的 link 匹配不到）
      listAuthed.value.some((item: any, index: number) => {
        const itemPath = (item.link || '').split('?')[0]
        const res = path === itemPath
        if (res) targetActiveTab = index
        return res
      })
      // 其次通过 activeRule 进行正则匹配
      if (targetActiveTab < 0) {
        listAuthed.value.some((item: any, index: number) => {
          const res = item.activeRule ? new RegExp(item.activeRule).test(path) : false
          if (res) targetActiveTab = index
          return res
        })
      }
      if (targetActiveTab >= 0) {
        activeTab.value = targetActiveTab
      }
    }
    watch(
      () => listAuthed,
      () => {
        findActiveTab()
      }
    )
    watch(
      () => route,
      () => {
        findActiveTab()
      }
    )
    findActiveTab()
    return {
      activeTab,
      listAuthed,
      findActiveTab,
      getIconMaskStyle
    }
  }
})
